import { useQuery } from '@tanstack/react-query'

import { fetchSurveyQuestions } from '../api'

const useSurveyQuestions = () => {
  return useQuery({
    queryKey: ['surveyQuestions'],
    queryFn: fetchSurveyQuestions,
  })
}

export default useSurveyQuestions
